import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { StatusHistory as BasicHealthStatusHistory } from "src/modules/basic-health";
import { StatusHistory as HtxStatusHistory } from "src/modules/htx";
import { StatusHistory as KdStatusHistory } from "src/modules/kd";
import { StatusHistory as KtxStatusHistory } from "src/modules/ktx";
import { StatusHistory as LtxStatusHistory } from "src/modules/ltx";

export const StatusHistory: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxStatusHistory />;
	}
	if (mod === "ktx") {
		return <KtxStatusHistory />;
	}
	if (mod === "kd") {
		return <KdStatusHistory />;
	}
	if (mod === "basic_health") {
		return <BasicHealthStatusHistory />;
	}
	if (mod === "ltx") {
		return <LtxStatusHistory />;
	}
	return null;
};
